import React, { useId } from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

export const Input: React.FC<InputProps> = ({ label, error, className = '', id, ...props }) => {
  const generatedId = useId();
  const inputId = id ?? generatedId;
  return (
    <div className="w-full">
      {label && (
        <label htmlFor={inputId} className="block text-sm font-medium text-text mb-1">
          {label}
        </label>
      )}
      <input
        id={inputId}
        className={`w-full px-3 py-2 bg-surface border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-primary-focus focus:border-primary transition-colors ${
          error ? 'border-no focus:ring-red-200' : 'border-border'
        } ${className}`}
        {...props}
      />
      {error && (
        <p className="mt-1 text-sm text-no">{error}</p>
      )}
    </div>
  );
};

export const Select: React.FC<React.SelectHTMLAttributes<HTMLSelectElement> & { label?: string }> = ({ label, className = '', id, children, ...props }) => {
  const generatedId = useId();
  const selectId = id ?? generatedId;
  return (
    <div className="w-full">
      {label && (
        <label htmlFor={selectId} className="block text-sm font-medium text-text mb-1">
          {label}
        </label>
      )}
      <select
        id={selectId}
        className={`w-full px-3 py-2 bg-surface border border-border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-primary-focus focus:border-primary transition-colors ${className}`}
        {...props}
      >
        {children}
      </select>
    </div>
  );
};
